import * as React from 'react';
import DataGrid from '../components/DataGrid';
import GetColumnDefs from '../components/ColumnDefs';
import { GetPermissions } from '../components/Options';
import { useNavigate } from "react-router-dom";
import configData from "../config.json";
import { GetSession, GetToken } from '../components/Session';
import { Notification } from "@progress/kendo-react-notification";
import { Fade } from "@progress/kendo-react-animation";

const UserApproval = () => {
    const [columns, setColumns] = React.useState(null);
    const [errorMessage, setErrorMessage] = React.useState(null);
    const [message, setMessage] = React.useState(null);
    const [permissions, setPermissions] = React.useState(null);
    const [doUpdate, setDoUpdate] = React.useState();
    const navigate = useNavigate();
    if (permissions && !permissions.CanView) navigate("/");
    if (localStorage.getItem("userid") === null) navigate("/logout");

    React.useEffect(() => { 
        GetColumnDefs("userapproval", setColumns, setErrorMessage); 
        GetPermissions(["ViewUserApproval", "ApproveUserApproval", "DeleteUserApproval", "ReportUserApproval"], setPermissions);
    }, [])

    const ApproveUser = (item) => {
        var st = item.isActive !== "Active";
        var url = `${configData.SERVER_URL}apiv7/private/approveuser/${item.userId}/${st}`;
        const init = {
          method: 'POST',
          accept: "application/json",
          headers: {
            "Content-type": "application/json",
            "Authorization": "Bearer " + GetToken()
          },
          mode: "cors",
          cache: "no-cache"
        }
        fetch(url, init).then(response => {
            if (response.status === 200) return response.text();
            return response;
        }).then(d => {           
            if (d === "true")
                setMessage("User was approved");
            else 
                setMessage("User was rejected");
            setDoUpdate(new Date());
            setErrorMessage("");
            setTimeout(() => {
                setMessage("");
                setErrorMessage("");
            }, 5000);
        });
    }

    return ( 
        <div>
            {errorMessage && <Fade><Notification type={{ style: "error", icon: true }}>{errorMessage}</Notification></Fade>}
            {message && <Fade><Notification type={{ style: "success", icon: true }}>{message}</Notification></Fade>}
            {columns && permissions && <DataGrid dataSource='apiv7/externalusers' columns={columns} approve={ApproveUser} permissions={permissions} keyField="userId" update={doUpdate} />}
        </div>       
    );
}

export default UserApproval;